import { LinkType, FinishType } from '@nerdwallet/react-apply-now';

export default ({ ctaCopy, ctaColumnTitle, showIcon }) => ({
  defaultSortKey: 'currentOffers',
  className: 'brokers',
  reviewTarget: '_blank',
  columns: [
    {
      title: 'Broker',
      className: 'broker',
      sort: {
        sortable: false,
        key: 'rating',
        order: 'desc',
      },
      content: [
        {
          type: 'image',
          config: {
            data_keys: ['product.institution.details.logo_url.value'],
            className: 'clearfix product-image-small',
            provider_key: 'name',
            provider_id: 'id',
            product_topic: 'Brokers',
            link_type: LinkType.institutionImage,
            finish_type: FinishType.externalApplicationReferral,
            link_data_key: 'derived_details.apply_link.value',
          },
        },
        {
          type: 'custom',
          component: 'ReviewAnnotation',
          config: {
            review_path: 'product.details.nw_review_url.value',
          },
        },
        {
          type: 'stars',
          value: 'additional_data.rating',
        },
      ],
    },
    {
      title: 'Highlights',
      className: 'highlights desktop-only',
      sort: {
        sortable: false,
        key: 'Highlights',
      },
      content: [
        {
          type: 'label',
          config: {
            data_keys: ['additional_data.summary_short'],
            className: 'annotation',
          },
        },
      ],
    },
    {
      title: 'Commissions',
      className: 'commissions',
      sort: {
        sortable: false,
        key: 'commissions',
      },
      content: [
        {
          type: 'label',
          config: {
            text: 'Commissions',
            className: 'column-header mobile',
          },
        },
        {
          type: 'label',
          config: {
            data_keys: ['product.details.flat_trade_price.value'],
            format: 'currency',
            className: 'product-value',
          },
        },
        {
          type: 'label',
          config: {
            data_keys: ['product.details.trade_price_caption.value'],
            className: 'annotation',
          },
        },
        {
          type: 'managementFee',
        },
      ],
    },
    {
      title: 'Account Minimum',
      className: 'account-minimum align-right-mobile',
      sort: {
        sortable: false,
        key: 'accountMinimum',
      },
      content: [
        {
          type: 'label',
          config: {
            text: 'Account Minimum',
            className: 'column-header mobile',
          },
        },
        {
          type: 'label',
          config: {
            data_keys: ['details.account_open_min.value'],
            format: 'currency-estimate',
            className: 'product-value',
          },
        },
      ],
    },
    {
      title: 'Current Offers',
      className: 'current-offers highlight-column',
      sort: {
        sortable: false,
        key: 'currentOffers',
      },
      content: [
        {
          type: 'label',
          config: {
            text: 'Current Offers',
            className: 'column-header mobile',
          },
        },
        {
          type: 'label',
          config: {
            data_keys: ['details.promotion_value.value'],
            className: 'product-value',
          },
        },
        {
          type: 'label',
          config: {
            data_keys: ['details.promotion_description.value'],
            className: 'annotation',
          },
        },
      ],
    },
    {
      title: ctaColumnTitle || 'Start Investing',
      className: 'start-investing cta-column',
      sort: {
        sortable: false,
        key: 'total',
      },
      content: [
        {
          type: 'label',
        },
        {
          type: 'apply',
          config: {
            data_keys: ['name', 'derived_details.apply_link.value'],
            provider_key: 'name',
            link_type: LinkType.applyNowButton,
            finish_type: FinishType.externalApplicationReferral,
            provider_id: 'id',
            product_topic: 'Brokers',
            link_data_key: 'derived_details.apply_link.value',
            ctype: 'Offer',
            buttonText: ctaCopy,
            show_icon: showIcon,
          },
        },
      ],
    },
  ],
  details: {
    component: 'broker_details',
  },
});
